export default function() {
    document.addEventListener('DOMContentLoaded', function () {
        const SearchInterfaceID = '_185F67BF-1D73-4AEE-9564-FDE5B0EB24D9';
        const SearchInterface = document.querySelectorAll('#' + SearchInterfaceID);
        const cSearch = SearchInterface[SearchInterface.length - 1];
        let phdArchiveSearchInterface = document.querySelector('.c-expand-search--archive .coveo-search-section div');
        let impactMapSearchInterface = document.querySelector('.impact-map .CoveoSearchInterface');
        let coveoMainSection = document.querySelector('.coveo-main-section');
        let observerStarted = false;
        const observer = new window.MutationObserver(filtersButtonAddedObserver);

        if(window.Coveo && cSearch && typeof window.Coveo !== 'undefined') {
            window.Coveo.$$(cSearch).on('beforeInitialization', function(e, args) {
                // Add alert popup to notify user when showing archived content
                let phdArchiveTab = window.document.querySelector('.CoveoTab[data-caption="Archives"]');

                if(phdArchiveTab) {
                    phdArchiveTab.addEventListener('click', archiveTabListener);
                    phdArchiveTab.addEventListener('keyup', archiveTabListener);
                }

                function archiveTabListener(e) {
                    if(e.type === 'keyup' && e.keyCode !== 13) {
                        return;
                    }

                    if(!e.currentTarget.classList.contains('coveo-selected')) {
                        window.alert('By applying this filter, only archived content will be presented. This content is preserved for historical reasons only.');
                    }
                }
            });

            window.Coveo.$$(cSearch).on('afterInitialization', function(e, args) {
                // Set Publish Date Facet Slider to today's date if it exists
                let coveoFacetSlider = document.querySelector('.CoveoFacetSlider');
                let currentDate = new Date();

                if(coveoFacetSlider) {
                    let facetSliderInstance = window.Coveo.get(coveoFacetSlider);
                    currentDate.setHours(0);
                    currentDate.setMinutes(0);
                    currentDate.setSeconds(0);
                    currentDate.setMilliseconds(0);
                    facetSliderInstance.initialEndOfSlider = currentDate.getTime();
                }
            });

            window.Coveo.$$(cSearch).on('noResults', function(e, args) {
                // Make Filters button visible after noResults event fired
                setFiltersButtonVisible();

                setTimeout(() => {
                    setFiltersButtonVisible();
                }, 1000);

                if(!observerStarted && coveoMainSection) {
                    observer.observe(coveoMainSection, {childList: true, subtree: true});
                    observerStarted = true;
                }
            });

            setTimeout(() => {
                // No results found event
                window.Coveo.$$(cSearch).on('deferredQuerySuccess', function(e, args) {
                    if(args.results.totalCount === 0) {
                        const coveoQuerySummaryCancelLastElement = cSearch.querySelector('.coveo-query-summary-cancel-last');
                        if(coveoQuerySummaryCancelLastElement) {
                            coveoQuerySummaryCancelLastElement.setAttribute('tabindex', '0');
                            coveoQuerySummaryCancelLastElement.setAttribute('role', 'button');
                            window.Coveo.$$(coveoQuerySummaryCancelLastElement).on('keypress', function(e) {
                                var keycode = (e.keyCode ? e.keyCode : e.which);
                                if(keycode === 13 || keycode === 32) {
                                    window.Coveo.$$(coveoQuerySummaryCancelLastElement).trigger('click');
                                }
                            });
                        }
                    }
                });
            }, 1000);
        }

        // For archive search pages, get the search input box and set the searchPageUri to point to the archive tab
        if(window.Coveo && phdArchiveSearchInterface && typeof window.Coveo !== 'undefined') {
            window.Coveo.$$(phdArchiveSearchInterface).on('afterInitialization', function() {
                let archivePageSearchBox = document.querySelectorAll('.c-expand-search--archive .CoveoSearchInterface');
                if(archivePageSearchBox.length > 0) {
                    let archivePageSearchBoxComponent = window.Coveo.get(archivePageSearchBox[0], window.Coveo.SearchInterface);
                    // Set custom searchPageUri, 'coveo5514054d' is the hard coded archive tab ID/data-id
                    archivePageSearchBoxComponent.options.searchPageUri = '/search#t=coveo5514054d&sort=relevancy';
                }
            });
        }

        // For Impact Map, add Filters button when it is not rendered by Coveo
        if(window.Coveo && impactMapSearchInterface && typeof window.Coveo !== 'undefined') {
            window.Coveo.$$(impactMapSearchInterface).on('afterInitialization', function() {
                var timeout = false;

                // Coveo does not add the Filters button on tablet sizes, so manually add it
                if(window.innerWidth > 847 && window.innerWidth < 992) {
                    appendCustomFiltersButton();
                }

                // Apply or remove the custom filters button based on screen size as needed
                window.addEventListener('resize', function() {
                    clearTimeout(timeout);
                    timeout = setTimeout(function() {
                        if(window.innerWidth > 847 && window.innerWidth < 992) {
                            appendCustomFiltersButton();
                        } else {
                            removeCustomFiltersButton();
                        }
                    }, 500);
                });
            });

            window.Coveo.$$(impactMapSearchInterface).on('deferredQuerySuccess', function() {
                var facetColumnElement = impactMapSearchInterface.querySelector('.coveo-facet-column');
                var customFiltersButtonElement = impactMapSearchInterface.querySelector('button.coveo-facet-dropdown-header.coveo-dropdown-header.coveo-accessible-button.impact-map__custom-filters-button');

                if(facetColumnElement && customFiltersButtonElement && facetColumnElement.className.indexOf('coveo-no-results') === -1) {
                    facetColumnElement.className = 'coveo-facet-column coveo-facet-dropdown-content coveo-dropdown-content';
                    customFiltersButtonElement.className += ' coveo-dropdown-header-active';
                }
            });
        }

        // Append custom filters button and container to DOM
        function appendCustomFiltersButton() {
            var coveoStateSearchElement = impactMapSearchInterface.querySelector('.coveo-search-section');
            var previouslyAppendedCustomFiltersButton = impactMapSearchInterface.querySelector('.impact-map__custom-filters-button-container');

            if(coveoStateSearchElement && previouslyAppendedCustomFiltersButton === null) {
                var newFiltersButtonContainer = createCustomFiltersButtonContainer();
                var newFiltersButton = createCustomFiltersButton();
                newFiltersButtonContainer.appendChild(newFiltersButton);
                coveoStateSearchElement.parentNode.insertBefore(newFiltersButtonContainer, coveoStateSearchElement.nextSibling);
            }
        }

        // Remove appended custom filters button and container from DOM
        function removeCustomFiltersButton() {
            var customFiltersButtonContainer = impactMapSearchInterface.querySelector('.impact-map__custom-filters-button-container');

            if(customFiltersButtonContainer) {
                customFiltersButtonContainer.parentNode.removeChild(customFiltersButtonContainer);
            }
        }

        // Create Filters button container for Impact Map
        function createCustomFiltersButtonContainer() {
            var newDropdownHeaderWrapper = document.createElement('DIV');
            newDropdownHeaderWrapper.className = 'coveo-dropdown-header-wrapper impact-map__custom-filters-button-container';
            return newDropdownHeaderWrapper;
        }

        // Create Filters button link for Impact Map
        function createCustomFiltersButton() {
            var newFiltersButton = document.createElement('BUTTON');
            var newFiltersButtonText = document.createElement('P');
            newFiltersButton.className = 'coveo-facet-dropdown-header coveo-dropdown-header coveo-accessible-button coveo-dropdown-header-active impact-map__custom-filters-button';
            newFiltersButton.setAttribute('role', 'button');
            newFiltersButton.setAttribute('aria-label', 'Filters');
            newFiltersButton.setAttribute('tabindex', '0');
            newFiltersButtonText.innerHTML = 'Filters';

            newFiltersButton.addEventListener('click', function(e) {
                var facetColumnElement = impactMapSearchInterface.querySelector('.coveo-facet-column');

                if(facetColumnElement) {
                    if(e.currentTarget.className.indexOf('coveo-dropdown-header-active') === -1) {
                        e.currentTarget.className += ' coveo-dropdown-header-active';
                        facetColumnElement.className = 'coveo-facet-column coveo-facet-dropdown-content coveo-dropdown-content';
                        facetColumnElement.style.display = 'block';
                    } else if(e.currentTarget.className.indexOf('coveo-dropdown-header-active') > -1) {
                        e.currentTarget.className = 'coveo-facet-dropdown-header coveo-dropdown-header coveo-accessible-button impact-map__custom-filters-button';
                        facetColumnElement.className = 'coveo-facet-column';
                        facetColumnElement.style.display = 'none';
                    }
                }
            });

            newFiltersButton.appendChild(newFiltersButtonText);
            return newFiltersButton;
        }
    });

    // Observer callback when Filters button markup is added, removes the 'coveo-hidden' class
    function filtersButtonAddedObserver(mutationList) {
        mutationList.forEach(mutationRecord => {
            if(mutationRecord.target.classList.contains('coveo-dropdown-header-wrapper')) {
                mutationRecord.addedNodes.forEach((node) => {
                    if(node.classList.contains('coveo-hidden') && node.ariaLabel === 'Filters') {
                        node.classList.remove('coveo-hidden');
                    }
                });
            }
        });
    }

    // Remove coveo-hidden class for Filters button
    function setFiltersButtonVisible(event) {
        let filtersButton = window.document.querySelector('a[aria-label="Filters"]');
        if(filtersButton) {
            filtersButton.classList.remove('coveo-hidden');
        }
    }
}



// WEBPACK FOOTER //
// ./src/app/utils/coveo-events.js